import React, { useEffect, useState } from 'react';
import { Button, Card, Tag } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { Col, Row } from 'react-bootstrap';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import * as _ from "lodash"
import PropTypes from 'prop-types';
import './index.css';

const OrderSummary = (props) => {
  const extraWorkId = useSelector(state => state.storage.extraWorkId);
  const { deliveryWindows, extraWork } = props;
  const [showAllBoxes, setShowAllBoxes] = useState(false);

  const { deliveryOrder } = useSelector((state) => state.storage);

  let extraCost = 0;

  if (extraWorkId) {
    let extraWorkObj = _.find(extraWork, { id: extraWorkId });

    if (extraWorkObj) {
      extraCost = Number(extraWorkObj.price);
    }
  }

  const deliveryDateString = moment(deliveryOrder?.deliveryDetails?.delivery_date).format('MMM DD, YYYY (dddd)');

  const deliveryWindow1 = deliveryWindows?.find(slot =>
    slot.unique_id === deliveryOrder?.deliveryDetails?.delivery_window_1_id ||
    slot.database_id === deliveryOrder?.deliveryDetails?.delivery_window_1_id ||
    slot.id === deliveryOrder?.deliveryDetails?.delivery_window_1_id
  );

  const deliveryWindow2 = deliveryWindows?.find(slot =>
    slot.unique_id === deliveryOrder?.deliveryDetails?.delivery_window_2_id ||
    slot.database_id === deliveryOrder?.deliveryDetails?.delivery_window_2_id ||
    slot.id === deliveryOrder?.deliveryDetails?.delivery_window_2_id
  );

  return (
    <>
      <Card title="Order Summary" className="order-summary-card">
        <Row className="ml-0 mr-0">
          <Col xxl={12} xl={12} lg={12} sm={12} xs={12}>
            <div className="summary-panel-content pl-0 pr-0 order-package">
              <div className="d-flex justify-content-between align-items-start mb-1 package-desc">
                <div style={{ flex: 1 }}>
                  <div className="d-flex align-items-center justify-content-between">
                    <span className="fw-600">
                      Delivery boxes ({deliveryOrder.requestedBoxes.length})
                    </span>
                    {deliveryOrder.requestedBoxes.length > 2 && (
                      <Button
                        type="link"
                        size="small"
                        onClick={() => setShowAllBoxes(!showAllBoxes)}
                        style={{ padding: '0 8px', fontSize: '12px' }}
                      >
                        {showAllBoxes ? (
                          <>
                            Hide <UpOutlined style={{ fontSize: '10px', marginLeft: '4px' }} />
                          </>
                        ) : (
                          <>
                            View all <DownOutlined style={{ fontSize: '10px', marginLeft: '4px' }} />
                          </>
                        )}
                      </Button>
                    )}
                  </div>

                  <div style={{ marginTop: '8px' }}>
                    {deliveryOrder.requestedBoxes.length <= 2 ? (
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                        {deliveryOrder.requestedBoxes.map((box, index) => (
                          <Tag key={index} color="blue" style={{ margin: 0 }}>
                            {box?.box_number}
                          </Tag>
                        ))}
                      </div>
                    ) : showAllBoxes ? (
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                        {deliveryOrder.requestedBoxes.map((box, index) => (
                          <Tag key={index} color="blue" style={{ margin: 0 }}>
                            {box?.box_number}
                          </Tag>
                        ))}
                      </div>
                    ) : (
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', alignItems: 'center' }}>
                        {deliveryOrder.requestedBoxes.slice(0, 2).map((box, index) => (
                          <Tag key={index} color="blue" style={{ margin: 0 }}>
                            {box?.box_number}
                          </Tag>
                        ))}
                        <span style={{ fontSize: '12px', color: '#666' }}>
                          +{deliveryOrder.requestedBoxes.length - 2} more
                        </span>
                      </div>
                    )}
                  </div>
                </div>

                {props?.boxPrices?.length > 0 && (
                  <span style={{ marginLeft: '12px', whiteSpace: 'nowrap' }}>
                    <p className='mb-0 text-center fw-600'>${Number(props?.boxPrices[1]?.price)}</p>
                  </span>
                )}
              </div>
            </div>
          </Col>
        </Row>

        <Row className="ml-0 mr-0 highlight-package ">
          <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
            <div className="summary-panel-content pl-0 pr-0 order-package ">
              <p className="text-left mb-1 fw-600 package-title" key="package">
                Delivery Date & Time
              </p>

              {
                deliveryOrder?.deliveryDetails?.delivery_date ?
                  (
                    <>
                      <p className="mb-0">{deliveryDateString}</p>
                      {deliveryWindow1 && (
                        <p className="mb-0">
                          {deliveryWindow1.display_value || `${deliveryWindow1.start_time}-${deliveryWindow1.end_time}`}
                        </p>
                      )}
                      {deliveryWindow2 && (
                        <p className="mb-0">
                          {deliveryWindow2.display_value || `${deliveryWindow2.start_time}-${deliveryWindow2.end_time}`}
                        </p>
                      )}
                    </>
                  ) :
                  (
                    <>
                      <p className="mb-0">No date selected</p>
                    </>
                  )
              }
            </div>
          </Col>
        </Row>

        {
          extraCost > 0 &&
          < Row className="ml-0 mr-0">
            <Col xxl={12} xl={12} lg={12} sm={12} xs={12}>
              <div className="summary-panel-content pl-0 pr-0 order-package">
                <p
                  className="text-left d-flex justify-content-between align-items-center mb-1 package-desc"
                  key={'package_value'}>
                  {
                    extraCost > 0 ? (
                      <>
                        <>
                          <span>Stairs/Elevators</span>
                          <span>${extraCost}</span>
                        </>
                      </>
                    ) :
                      (
                        <>

                        </>
                      )
                  }
                </p>
              </div>
            </Col>
          </Row>
        }

        <div className="summary-footer  bg-theme-secondary  mb-0 d-flex">
          <div className='col-6 fw-600'>
            Total Cost
          </div>
          <div className='col-6 fw-600 text-right'>
            ${deliveryOrder?.requestedBoxes?.length > 0 ? 29 + (extraCost ? extraCost : 0) : 0}
          </div>
        </div>
      </Card>
    </>
  );
};

export default OrderSummary;


OrderSummary.propTypes = {
  deliveryWindows: PropTypes.any,
  extraWork: PropTypes.any,
  boxPrices: PropTypes.any
};